/** Client-only collection discovery; never modifies products, URLs or analytics. */
class LoraCollectionDirectory extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controls = this.querySelector('[data-directory-controls]');
    this.search = this.querySelector('[data-directory-search]');
    this.status = this.querySelector('[data-directory-status]');
    this.empty = this.querySelector('[data-directory-empty]');
    if (!this.controls || !this.search || !this.status || !this.empty) return;
    this.cards = [...this.querySelectorAll('[data-directory-card]')];
    this.groups = [...this.querySelectorAll('[data-directory-group]')];
    this.filters = [...this.querySelectorAll('[data-directory-filter]')];
    this.group = 'all';
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.controls.addEventListener('submit', event => event.preventDefault(), options);
    this.search.addEventListener('input', () => this.filter(), options);
    for (const filter of this.filters) {
      const group = filter.dataset.directoryFilter;
      filter.hidden = group !== 'all' && !this.cards.some(card => card.dataset.group === group);
      filter.addEventListener('click', () => {
        this.group = group;
        this.filter();
      }, options);
    }
    for (const reset of this.querySelectorAll('[data-directory-reset]')) {
      reset.addEventListener('click', () => {
        this.search.value = '';
        this.group = 'all';
        this.filter();
        this.search.focus();
      }, options);
    }
    this.filter();
    this.controls.hidden = false;
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }

  /** Match words and model-style punctuation without changing the typed query. */
  normalize(value) {
    return String(value || '').normalize('NFKC').toLocaleLowerCase().replace(/[\u0591-\u05C7]/g, '').replace(/[^\p{L}\p{N}]+/gu, '');
  }

  filter() {
    const query = this.normalize(this.search.value);
    let count = 0;
    for (const card of this.cards) {
      const groupMatches = this.group === 'all' || this.group === card.dataset.group;
      const searchMatches = !query || this.normalize(card.dataset.search).includes(query);
      card.hidden = !groupMatches || !searchMatches;
      if (!card.hidden) count += 1;
    }
    for (const group of this.groups) {
      group.hidden = !this.cards.some(card => card.dataset.group === group.dataset.directoryGroup && !card.hidden);
    }
    for (const filter of this.filters) {
      filter.setAttribute('aria-pressed', String(filter.dataset.directoryFilter === this.group));
    }
    this.empty.hidden = count !== 0;
    this.status.textContent = `${count} ${this.dataset.countLabel}`;
  }
}
if (!customElements.get('lora-collection-directory')) customElements.define('lora-collection-directory', LoraCollectionDirectory);
